// extracted by mini-css-extract-plugin
export default {"reviewPromptButton":"reviewPromptButton_reviewPromptButton__T1qlg"};